module.exports = __webpack_public_path__ + "img/slika13.08d6363e.jpg";